export const templates = {
  SlideShow: 'SlideShow',
};
